import React from 'react';
import {Button, CircularProgress} from '@material-ui/core'

class ButtonComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    bgColor(type) {
        switch (type) {
            case "primary":
                return " bg-primary text-white ";
            case "secondary":
                return " bg-secondary text-white ";
            case "success":
                return " bg-green1-dark text-white ";
            case "danger":
                return " bg-red2-dark text-white ";
            case "warning":
                return " bg-highlight ";
            case"none":
                return "";
            default:
                return " bg-primary text-white ";
        }
    }

    render() {
        const {title, type, full, onClick, loading, classes, shadowType, children, disabled} = this.props;

        let className = 'btn btn-m rounded-sm text-uppercase font-900 btn-full mt-2 mb-2';
        className += this.bgColor(type);
        className += ` shadow-${shadowType} `;
        className += classes;

        let styles = {};

        if (full)
            Object.assign(styles, {width: '100%'});

        return (
            <Button className={className} style={styles} onClick={onClick} disabled={loading || disabled}>
                {!loading ? title : <CircularProgress size={16} color={(type == undefined || type == 'primary' || type == 'success') ? 'secondary' : 'primary'}/>}
                {!loading && children}
            </Button>
        );
    }
}

export default ButtonComponent;